export const HOME = {
  emergentLink: "home-emergent-link",
  heroCta: "hero-cta-get-started",
  farmerCard: "role-card-farmer",
  workerCard: "role-card-day_worker",
  investorCard: "role-card-investor",
  loginLink: "nav-login-link",
};

export const AUTH = {
  roleFarmer: "role-select-farmer",
  roleWorker: "role-select-day_worker",
  roleInvestor: "role-select-investor",
  nameInput: "register-name",
  mobileInput: "register-mobile",
  emailInput: "register-email",
  dobInput: "register-dob",
  stateInput: "register-state",
  districtInput: "register-district",
  villageInput: "register-village",
  genderInput: "register-gender",
  passwordInput: "register-pwd",
  confirmInput: "register-confirm",
  termsInput: "register-terms",
  registerSubmit: "register-submit",
  loginIdentifier: "login-identifier",
  loginPassword: "login-pwd",
  loginSubmit: "login-submit",
  toRegister: "switch-to-register",
  toLogin: "switch-to-login",
};

export const DASH = {
  container: "dashboard-container",
  postProduct: "dash-post-product",
  postService: "dash-post-service",
  goMarketplace: "dash-go-marketplace",
  goMessages: "dash-go-messages",
  goNotifications: "dash-go-notifications",
  goOrders: "dash-go-orders",
  logout: "dash-logout",
};

export const LISTING = {
  submit: "listing-submit",
  name: "listing-name",
  price: "listing-price",
  category: "listing-category",
  description: "listing-description",
  desc: "listing-description",
  contact: "listing-contact",
  imageUrl: "listing-image-url",
  addImage: "listing-add-image",
  interestedBtn: "listing-interested",
  buyBtn: "listing-buy",
  chatBtn: "listing-chat",
  callBtn: "listing-call",
  checkoutBtn: "checkout-confirm",
};
